import { EMPTY, jiraBrowseUrl, routes } from '@pmai/contracts';
import { Fragment } from 'react';
import { useApiQuery } from '../../shared/api/hooks';
import { ExternalLink } from '../../shared/external-link';

/** The workspace's Jira site for links; `null` without a connection (FR-PRJ-015). */
export function useJiraBaseUrl(): string | null {
  return useApiQuery(routes.jira.site, {}, { staleTime: 5 * 60_000 }).data?.baseUrl ?? null;
}

/** A Jira key as a link to `<site>/browse/<KEY>` in a new tab, or plain text without a site. */
export function JiraKey({ jiraKey, baseUrl }: { jiraKey: string; baseUrl: string | null }) {
  return baseUrl ? (
    <ExternalLink href={jiraBrowseUrl(baseUrl, jiraKey)} label={jiraKey} />
  ) : (
    <span>{jiraKey}</span>
  );
}

/** Comma-separated keys, each its own link; none → "–" (FR-PRJ-015). */
export function JiraKeyLinks({ keys }: { keys: readonly string[] }) {
  const baseUrl = useJiraBaseUrl();
  if (keys.length === 0) return <span className="text-ink-muted">{EMPTY}</span>;
  return (
    <span>
      {keys.map((k, i) => (
        <Fragment key={k}>
          {i > 0 && ', '}
          <JiraKey jiraKey={k} baseUrl={baseUrl} />
        </Fragment>
      ))}
    </span>
  );
}
